module.exports = __webpack_public_path__ + "img/Kyoto-01.69777942.jpg";